import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import { previewHistoryBatch } from '../../../../store/extensions';
import BackdropHlsAdjustmentSlider from './BackdropHlsAdjustmentSlider';

const BackdropHlsAdjustmentAlphaListItem = (props) => {
    const { hlsAdjustmentAlpha, maxHlsAdjustmentAlpha, updateBackgroundSettings } = props;

    const onIntensityChange = (value) => {
        previewHistoryBatch.start();
        updateBackgroundSettings({ hlsAdjustment: { alpha: value } });
    }

    return (
        <BackdropHlsAdjustmentSlider
            title='Intensity'
            value={hlsAdjustmentAlpha}
            min={0}
            max={maxHlsAdjustmentAlpha * 100}
            step={0.1}
            onValueChange={onIntensityChange}
            hideArrows
        />
    );
};

const mapStateToProps = (state) => {
    const hlsAdjustmentAlpha = state.createPreview.present.videoSettings.background.hlsAdjustment.alpha;
    const { maxHlsAdjustmentAlpha } = state.create.maxValues;

    return {
        hlsAdjustmentAlpha,
        maxHlsAdjustmentAlpha
    }
}

const mapDispatchToProps = (dispatch) => {
    const updateBackgroundSettings = (properties) => dispatch(createActions.updateBackgroundSettings(properties));
    return { updateBackgroundSettings }
}

export default connect(mapStateToProps, mapDispatchToProps)(BackdropHlsAdjustmentAlphaListItem);